export default __webpack_public_path__ + "static/cdc5-e3cfaf47c1398e238b68633a946b1833.jpg";